import cn from "classnames";
import { If } from "components/If";
import { t } from "i18next";
import { NavLink } from "react-router-dom";

import { TabLinkProps } from "./TabLink.types";

import styles from "./TabLink.module.scss";

const TabLink = ({
  pathName,
  label,
  counterValue,
  forceActive
}: TabLinkProps) => {
  return (
    <NavLink
      to={pathName}
      className={({ isActive }) =>
        cn(styles.link, { [styles.link__active]: isActive || forceActive })
      }
    >
      <span>{t(label)}</span>

      <If condition={counterValue !== undefined}>
        <span className={styles.counterValue}>{counterValue}</span>
      </If>
    </NavLink>
  );
};

export default TabLink;
